import {event} from '../modules/event';

class Thetop {
    constructor(box) {
        this._createElements(box);

        if (document.readyState === "complete") {
            this._addEvents();
        } else {
            var self = this;
            event.add(window, 'load', function(){
                self._addEvents.call(self);
            });
        }
    }

    _createElements(box){
        this.box = box;
        this.boxH = 167;
        this.top = this.box.getBoundingClientRect().top;
        this.offset = this.top + this.boxH;
        this.minWidth = 990;
        this.clear;
    }

    _addEvents(){
        var self = this;
        var f = function(e){
            try{clearTimeout(self.clear)} catch(e){};

            self.clear = setTimeout(function(){
                if(window.pageYOffset > self.offset){
                    event.remove(window, 'scroll', f);
                    self._show.call(self);
                }
            }, 300);
        }

        //
        event.add(window, 'scroll', f);
        //f();
    }

    _show(){
        var top = window.pageYOffset;
        this.box.className = this.box.className + ' js-active';

        /* ФФ не прокручивает страницу, а хром сам автоматом крутит, оставляя содержимое на этом же месте */
        if(top == window.pageYOffset) window.scrollBy(0, this.boxH);
    }
}

export {Thetop};




































